"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importStar(require("styled-components"));
const styled_tools_1 = require("styled-tools");
const colorTypes_1 = require("../constants/colorTypes");
function getColors(props) {
    const { isActive, isDisabled, theme } = props;
    if (isActive) {
        if (theme.isClassic) {
            return (0, styled_components_1.css) `
        color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabTextColorDarkActive,
                [colorTypes_1.LIGHT]: theme.tabTextColorLightActive,
            })};
        border-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBorderColorDarkActive,
                [colorTypes_1.LIGHT]: theme.tabBorderColorLightActive,
            })};
        background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBackgroundDarkActive,
                [colorTypes_1.LIGHT]: theme.tabBackgroundLightActive,
            })};

        &::after {
          background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBorderColorDarkActive,
                [colorTypes_1.LIGHT]: theme.tabBorderColorLightActive,
            })};
        }
      `;
        }
        return (0, styled_components_1.css) `
      color: ${theme.textColorActive};
      border-color: ${theme.tabBorderColorActive};
      background: ${theme.tabBackgroundActive};

      &::after {
        background: ${theme.tabBorderColorActive};
      }
    `;
    }
    if (isDisabled) {
        if (theme.isClassic) {
            return (0, styled_components_1.css) `
        color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabTextColorDarkDisabled,
                [colorTypes_1.LIGHT]: theme.tabTextColorLightDisabled,
            })};
        border-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBorderColorDarkDisabled,
                [colorTypes_1.LIGHT]: theme.tabBorderColorLightDisabled,
            })};
        background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBackgroundDarkDisabled,
                [colorTypes_1.LIGHT]: theme.tabBackgroundLightDisabled,
            })};

        &::after {
          background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
                [colorTypes_1.DARK]: theme.tabBorderColorDarkDisabled,
                [colorTypes_1.LIGHT]: theme.tabBorderColorLightDisabled,
            })};
        }
      `;
        }
        return (0, styled_components_1.css) `
      color: ${theme.textColorDisabled};
      border-color: ${theme.tabBorderColorDisabled};
      background: ${theme.tabBackgroundDisabled};

      &::after {
        background: ${theme.tabBorderColorDisabled};
      }
    `;
    }
    if (theme.isClassic) {
        return (0, styled_components_1.css) `
      color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabTextColorDark,
            [colorTypes_1.LIGHT]: theme.tabTextColorLight,
        })};
      border-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBorderColorDark,
            [colorTypes_1.LIGHT]: theme.tabBorderColorLight,
        })};
      background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBackgroundDark,
            [colorTypes_1.LIGHT]: theme.tabBackgroundLight,
        })};

      &::after {
        background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBorderColorDark,
            [colorTypes_1.LIGHT]: theme.tabBorderColorLight,
        })};
      }

      &:hover,
      &:focus {
        color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabTextColorDarkHover,
            [colorTypes_1.LIGHT]: theme.tabTextColorLightHover,
        })};
        border-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBorderColorDarkHover,
            [colorTypes_1.LIGHT]: theme.tabBorderColorLightHover,
        })};
        background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBackgroundDarkHover,
            [colorTypes_1.LIGHT]: theme.tabBackgroundLightHover,
        })};

        &::after {
          background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabBorderColorDarkHover,
            [colorTypes_1.LIGHT]: theme.tabBorderColorLightHover,
        })};
        }
      }
    `;
    }
    return (0, styled_components_1.css) `
    color: ${theme.textColor};
    border-color: ${theme.tabBorderColor};
    background: ${theme.tabBackground};

    &::after {
      background: ${theme.tabBorderColor};
    }

    &:hover {
      color: ${theme.textColorHover};
      border-color: ${theme.tabBorderColorHover};
      background: ${theme.tabBackgroundHover};

      &::after {
        background: ${theme.tabBorderColorHover};
      }
    }

    &:focus-visible {
      color: ${theme.textColorFocus};
      background: ${theme.tabBackgroundHover};
    }
  `;
}
function getStretchedStyles(props) {
    const { isStretched } = props;
    if (isStretched) {
        return (0, styled_components_1.css) `
      align-items: stretch;
      width: 100%;
    `;
    }
    return (0, styled_components_1.css) `
    flex: none;
    width: auto;
  `;
}
const TabItem = styled_components_1.default.button.attrs(props => ({
    disabled: props.isDisabled,
    'aria-selected': props.isActive,
    type: props.type,
})) `
  ${({ theme, isActive }) => {
    return (0, styled_components_1.css) `
      font-family: ${isActive ? theme.selectedFontFamily : theme.fontFamily};
      font-size: ${isActive ? theme.selectedFontSize : theme.fontSize};
      font-weight: ${isActive ? theme.selectedFontWeight : theme.fontWeight};
      line-height: ${isActive ? theme.selectedLineHeight : theme.lineHeight};
      letter-spacing: ${isActive
        ? theme.selectedLetterSpacing
        : theme.letterSpacing};
    `;
}}
  position: relative;
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.tabGap};
  height: ${({ theme }) => `calc(${theme.tabHeight} - ${theme.tabGap})`};
  max-width: ${({ theme }) => theme.tabMaxWidth};
  min-width: ${({ theme }) => theme.tabMinWidth};
  padding: ${({ theme }) => theme.tabPadding};
  border-radius: ${({ theme }) => theme.tabBorderRadius};
  border-width: ${({ theme }) => theme.tabBorderTopSize}
    ${({ theme }) => theme.tabBorderRightSize} 0
    ${({ theme }) => theme.tabBorderLeftSize};
  border-style: solid;
  box-sizing: border-box;
  cursor: ${props => props.isActive || props.isDisabled ? 'default' : 'pointer'};

  transition-property: border-color, color, background, box-shadow;
  transition-duration: ${({ theme }) => theme.tabTransitionTime};
  transition-timing-function: ease-in;

  ${props => getColors(props)};
  ${props => getStretchedStyles(props)}

  overflow-x: clip;

  &:hover {
    outline: none;
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.tabBorderSizeFocus} solid
      ${({ theme }) => theme.tabBorderColorFocus};
    outline-offset: -${({ theme }) => theme.tabBorderSizeFocus};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -${({ theme }) => theme.tabGap};
    left: 0;
    width: 100%;
    height: ${({ theme }) => theme.tabBorderBottomSize};
    transition: background ${({ theme }) => theme.tabTransitionTime} ease-in;
    z-index: 2;
  }
`;
TabItem.propTypes = {
    /**
     * Button type
     */
    type: prop_types_1.default.oneOf(['button', 'reset', 'submit']),
    /**
     * Disabled state for button
     */
    isDisabled: prop_types_1.default.bool,
};
TabItem.defaultProps = {
    type: 'button',
    isDisabled: false,
};
exports.default = TabItem;
